export enum InitStatus {
  PLANNING = "PLANNING",
  EVAL_STARTED = "EVAL_STARTED",
  SELECTED = "SELECTED",
}

export enum InitState {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

export enum InitProdState {
  AWARDED = "AWARDED",
  IN_EVALUATION = "IN_EVALUATION",
  LISTED = "LISTED",
  SCREENED_OUT = "SCREENED_OUT",
}

export enum InitUserRole {
  CONTRIBUTOR = "CONTRIBUTOR",
  OWNER = "OWNER",
  VIEWER = "VIEWER",
}

export enum InitUserRoleLabel {
  CONTRIBUTOR = "Contributor",
  OWNER = "Owner",
  VIEWER = "Viewer",
}

export enum ChecklistPhaseStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
}

export enum ReviewType {
  FAVORABLE = "FAVORABLE",
  CRITICAL = "CRITICAL",
}

export enum ScorecardProgress {
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum ScoringLevel {
  CATEGORY = "CATEGORY",
  REQUIREMENT = "REQUIREMENT",
  NONE = "NONE",
}

export enum ScoringMode {
  NONE = "NONE",
  AUTO_ASSIGNMENT = "AUTO_ASSIGNMENT",
  MANUAL_ASSIGNMENT = "MANUAL_ASSIGNMENT",
}

export enum ScorecardState {
  NONE = "NONE",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum RequirementsState {
  DRAFT = "DRAFT",
  INEDIT = "INEDIT",
  PUBLISHED = "PUBLISHED",
}

export enum PriorityWeightOption {
  NONE = 0,
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}

export enum FreeTrialRole {
  FREE_TRIAL_RECIPIENT = "FREE_TRIAL_RECIPIENT",
  FREE_TRIAL_GUEST = "FREE_TRIAL_GUEST",
}

export enum GartnerQuadrant {
  TOP_LEFT = "Challenger",
  TOP_RIGHT = "Leader",
  BOTTOM_RIGHT = "Visionary",
  BOTTOM_LEFT = "Niche Player",
  NONE = "NONE",
}

export enum GcomDocType {
  MARKET_GUIDE = "MARKET_GUIDE",
  EMERGING_MARKET_QUAD = "EMERGING_MARKET_QUAD",
  MAGIC_QUAD = "MAGIC_QUAD",
  TOOL = "TOOL",
}

export enum SurveyState {
  NONE = "NONE",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum InitActivity {
  CHECKLIST_PHASE_COMPLETED = "CHECKLIST_PHASE_COMPLETED",
  CHECKLIST_TASK_COMPLETED = "CHECKLIST_TASK_COMPLETED",
  PRODUCT_SCREENED_OUT = "PRODUCT_SCREENED_OUT",
  PRODUCT_SELECTED = "PRODUCT_SELECTED",
  PRODUCT_SELECTED_REVERTED = "PRODUCT_SELECTED_REVERTED",
  REQUIREMENTS_PUBLISHED = "REQUIREMENTS_PUBLISHED",
  ROUND_CLOSED_TO_RESPONSES = "ROUND_CLOSED_TO_RESPONSES",
  ROUND_CREATED = "ROUND_CREATED",
  ROUND_DELETED = "ROUND_DELETED",
  ROUND_REOPENED_FOR_RESPONSES = "ROUND_REOPENED_FOR_RESPONSES",
  SURVEY_RECIPIENT_INITIAL_OPENS_SURVEY = "SURVEY_RECIPIENT_INITIAL_OPENS_SURVEY",
  SURVEY_RECIPIENT_SHARES_RESPONSES = "SURVEY_RECIPIENT_SHARES_RESPONSES",
  TEAM_MEMBER_JOINED = "TEAM_MEMBER_JOINED",
  TEAM_MEMBER_SCORING_COMPLETED = "TEAM_MEMBER_SCORING_COMPLETED",
  VENDOR_SELECTION_DATE_UPDATED = "VENDOR_SELECTION_DATE_UPDATED",
}

export enum InitTeamAssociation {
  EVALUATOR = "EVALUATOR",
  SURVEY_RECIPIENT = "SURVEY_RECIPIENT",
}

export enum RoundType {
  SCORECARD = "SCORECARD",
  SURVEY = "SURVEY",
}

export enum ProductStateDialogAction {
  AWARD = "AWARD",
  REVERT_AWARD = "REVERT_AWARD",
  REVERT_SCREEN_OUT = "REVERT_SCREEN_OUT",
  SCREEN_OUT = "SCREEN_OUT"
}